import { Text, View } from "@react-pdf/renderer";
import { layoutStyles, textStyles } from ".";

export default function PrintTitle({
    englishTitle,
    arabicTitle,
}: {
    englishTitle: string;
    arabicTitle: string;
}) {
    return (
        <View style={layoutStyles.flexCenter}>
            <View
                style={{
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: "20px",
                    fontSize: "12px",
                    fontWeight: 700,
                }}
            >
                <Text style={textStyles.arabicText}>{arabicTitle}</Text>
                <Text>{englishTitle}</Text>
            </View>
        </View>
    );
}
